import { setAttribute, setText, toggleClass, isNumeric } from '../helpers/attribute-helper';
import { escape as escapeHTML } from 'html-escaper';
import Tooltip from '../../utils/tooltip';

export default class PromotionsManager {
  constructor(parent) {
    this.parent = parent;
    this.el = parent.el;
    this.pricing = parent.pricing;
    this.car = parent.car;
    this.promotionsHelper = parent.promotionsHelper;
    this.promotionsDropdown = this.el?.querySelector('.promotions-dropdown');
    this.promotionsModal = this.el?.querySelector('.promotions-modal');
    this.promotionsTerms = this.el?.querySelector('.promotions-terms-container');
    this.container = this.el?.querySelector('.promotions-modal-content');
    this.template = _.template(parent.el.querySelector('#promotions-modal-template').innerHTML.replaceAll('\\', ''));
    this.bind();
  }

  bind() {
    if(this.promotionsDropdown) {
      this.promotionsDropdown.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggle();
      });

      this.el.addEventListener('click', (e) => {
        if (!e.target.closest('.promotions-modal') && !e.target.closest('.promotions-dropdown')) {
            this.hide();
        }
      });
    }    
  }

  hide() {
    if (this.promotionsModal.classList.contains('open')){
      this.promotionsDropdown?.classList.remove('open');
      this.promotionsModal?.classList.remove('open');
    }
  }

  toggle() {
    this.promotionsDropdown?.classList.toggle('open');
    this.promotionsModal?.classList.toggle("open");
  }

  async update() {
    await this.pricing.waitForMTOPricing();

    this.updateMTOPromotions();
    this.updateColourTrimPromotions();
    this.updateAccessoryPromotions();
    this.updateWheelPromotions();
    this.updateAdditionalProductPromotions();
    Tooltip.init('.discount-tooltip', this.promotionsHelper.tooltipOptions);

    await this.pricing.getMTOCEPricing();
    if(!this.pricing.hasPricing()) { return; }

    this.updateCarPromotions();
    this.updateTermsAndConditions();
    this.updateModal();
    Tooltip.init('.discount-tooltip', this.promotionsHelper.tooltipOptions);
  }

  updateMTOPromotions() {
    const mtoPricesDiscount = this.pricing.getMTOPrices({ discountPrice: true });
    const mtoPromotionTooltips = this.promotionsHelper.getMTOPromotionTooltips();
    setText(this.el, mtoPricesDiscount, 'data-mto-price-discount', (val, el) => this.pricing.format(val, true, el));
    toggleClass(this.el, mtoPricesDiscount, 'data-mto-price-discount-toggle', 'hide', false, isNumeric);
    toggleClass(this.el, mtoPricesDiscount, 'data-mto-price-discount-strike', 'strike', true, isNumeric);
    setAttribute(this.el, mtoPromotionTooltips, 'data-mto-price-discount-toggle', 'data-tippy-content');
  }

  updateColourTrimPromotions() {
    const carColourPrice = this.pricing.getCarBreakdownColourPrice();
    const carTrimPrice = this.pricing.getCarBreakdownTrimPrice();
    const carColourTrimPriceDiscount = this.pricing.getCarColourTrimPrice({ discountPrice: true });
    const carColourTrimPromotionTooltip = this.promotionsHelper.getCarColourTrimTooltip();
    setText(this.el, carColourTrimPriceDiscount, 'data-car-colour-trim-price-discount', (val, el) => this.pricing.format(val, true, el));
    toggleClass(this.el, carColourTrimPriceDiscount, 'data-car-colour-trim-price-discount-toggle', 'hide', false, isNumeric);
    toggleClass(this.el, carColourTrimPriceDiscount, 'data-car-colour-price-discount-strike', carColourPrice > 0 ? 'strike' : '', true, isNumeric);
    toggleClass(this.el, carColourTrimPriceDiscount, 'data-car-trim-price-discount-strike', carTrimPrice > 0 ? 'strike' : '', true, isNumeric);
    setAttribute(this.el, carColourTrimPromotionTooltip, 'data-car-colour-trim-price-discount-tooltip', 'data-tippy-content');
  }

  updateAccessoryPromotions() {
    const accessoryPricesDiscount = this.pricing.getAccessoryPrices({ discountPrice: true });
    const accessoryPromotionTooltips = this.promotionsHelper.getAccessoryPromotionTooltips();
    setText(this.el, accessoryPricesDiscount, 'data-accessory-price-discount', (val, el) => this.pricing.format(val, true, el));
    toggleClass(this.el, accessoryPricesDiscount, 'data-accessory-price-discount-toggle', 'hide', false, isNumeric);
    toggleClass(this.el, accessoryPricesDiscount, 'data-accessory-price-discount-strike', 'strike', true, isNumeric);
    setAttribute(this.el, accessoryPromotionTooltips, 'data-accessory-price-discount-toggle', 'data-tippy-content');
  }

  updateWheelPromotions() {
    const carWheelPriceDiscount = this.pricing.getWheelPrices({ discountPrice: true })?.[this.car.wheelMTOCE()];
    const carWheelPromotionTooltip = this.promotionsHelper.getAccessoryPromotionTooltips()?.[this.car.wheelMTOCE()];
    setText(this.el, carWheelPriceDiscount, 'data-car-wheel-price-discount', (val, el) => this.pricing.format(val, true, el));
    toggleClass(this.el, carWheelPriceDiscount, 'data-car-wheel-price-discount-toggle', 'hide', false, isNumeric);
    toggleClass(this.el, carWheelPriceDiscount, 'data-car-wheel-price-discount-strike', 'strike', true, isNumeric);
    setAttribute(this.el, carWheelPromotionTooltip, 'data-car-wheel-price-discount-toggle', 'data-tippy-content');
  }

  updateAdditionalProductPromotions() {
    const additionalProductPricesDiscount = this.pricing.getAdditionalProductPricesMTO({ discountPrice: true });
    const additionalProductPromotionTooltips = this.promotionsHelper.getAdditionalProductPromotionTooltips();
    setText(this.el, additionalProductPricesDiscount, 'data-additional-product-price-discount', (val, el) => this.pricing.format(val, true, el));
    toggleClass(this.el, additionalProductPricesDiscount, 'data-additional-product-price-discount-toggle', 'hide', false, isNumeric);
    toggleClass(this.el, additionalProductPricesDiscount, 'data-additional-product-price-discount-strike', 'strike', true, isNumeric);
    setAttribute(this.el, additionalProductPromotionTooltips, 'data-additional-product-price-discount-toggle', 'data-tippy-content');
  }

  updateCarPromotions() {
    const carTotalPriceDiscount = this.pricing.getCarTotalPrice({ discountPrice: true });
    setText(this.el, carTotalPriceDiscount, 'data-car-total-price-discount', (val, el) => this.pricing.format(val, true, el));
    toggleClass(this.el, carTotalPriceDiscount, 'data-car-total-price-discount-toggle', 'hide', false, isNumeric);
    toggleClass(this.el, carTotalPriceDiscount, 'data-car-total-price-discount-hide', 'hide', true, isNumeric);
    toggleClass(this.el, carTotalPriceDiscount, 'data-car-total-price-discount-strike', 'strike', true, isNumeric);

    const carAccessoriesPriceDiscount = this.pricing.getCarAccessoriesPrice({ discountPrice: true });
    setText(this.el, carAccessoriesPriceDiscount, 'data-car-accessories-price-discount', (val, el) => this.pricing.format(val, true, el));
    toggleClass(this.el, carAccessoriesPriceDiscount, 'data-car-accessories-price-discount-toggle', 'hide', false, isNumeric);
    toggleClass(this.el, carAccessoriesPriceDiscount, 'data-car-accessories-price-discount-strike', 'strike', true, isNumeric);
  }

  updateModal() {
    this.container.innerHTML = this.template({
      promotions: this.promotionsHelper.getCarPromotions(),
      total: this.promotionsHelper.getCarPromotionsDiscountTotal(),
      formatPrice: (val) => this.pricing.format(val),
      escapeHTML,
    });
  }

  updateTermsAndConditions() {
    const promotions = this.promotionsHelper.getCarPromotions();
    this.promotionsTerms.innerHTML = promotions.map((promotion) => promotion.terms).join('');
  }
}